/* global chrome */
import { configureStore } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

// Import your individual reducers here
import authReducer from './slices/authSlice';
import workspaceReducer from './slices/workspaceSlice';
// Import other reducers as needed

// Combine all reducers
const rootReducer = combineReducers({
  auth: authReducer,
  workspace: workspaceReducer,
  // Add other reducers here
});

// Configure persistence
const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth', 'workspace'] // Only persist these reducers
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

// Create the store with default configuration
const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }),
});
// Create persistor
const persistor = persistStore(store);

// Check if we're in a browser extension context
const isExtension = typeof chrome !== 'undefined' && chrome.runtime && chrome.runtime.id;

// If we're in an extension, also sync with chrome.storage
if (isExtension) {
  // Add middleware to save state changes to chrome.storage
  store.dispatch = (function(next) {
    return function(action) {
      const result = next(action);
      const state = store.getState();
      
      // Save specific parts of state to chrome.storage
      if (action.type.includes('auth/') || action.type.includes('workspace/')) {
        chrome.storage.local.set({
          reduxState: JSON.stringify({
            auth: state.auth,
            workspace: state.workspace
          })
        });
      }
      
      return result;
    };
  })(store.dispatch);
}

export { store, persistor }; 